import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Public\PageController::show
* @see app/Http/Controllers/Public/PageController.php:20
* @route 'https://mktcode.digital/page/{page}'
*/
export const show = (args: { page: string | number | { slug: string | number } } | [page: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://mktcode.digital/page/{page}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Public\PageController::show
* @see app/Http/Controllers/Public/PageController.php:20
* @route 'https://mktcode.digital/page/{page}'
*/
show.url = (args: { page: string | number | { slug: string | number } } | [page: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { page: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { page: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            page: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        page: typeof args.page === 'object'
        ? args.page.slug
        : args.page,
    }

    return show.definition.url
            .replace('{page}', parsedArgs.page.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Public\PageController::show
* @see app/Http/Controllers/Public/PageController.php:20
* @route 'https://mktcode.digital/page/{page}'
*/
show.get = (args: { page: string | number | { slug: string | number } } | [page: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\PageController::show
* @see app/Http/Controllers/Public/PageController.php:20
* @route 'https://mktcode.digital/page/{page}'
*/
show.head = (args: { page: string | number | { slug: string | number } } | [page: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Public\PageController::show
* @see app/Http/Controllers/Public/PageController.php:20
* @route 'https://mktcode.digital/page/{page}'
*/
const showForm = (args: { page: string | number | { slug: string | number } } | [page: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\PageController::show
* @see app/Http/Controllers/Public/PageController.php:20
* @route 'https://mktcode.digital/page/{page}'
*/
showForm.get = (args: { page: string | number | { slug: string | number } } | [page: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Public\PageController::show
* @see app/Http/Controllers/Public/PageController.php:20
* @route 'https://mktcode.digital/page/{page}'
*/
showForm.head = (args: { page: string | number | { slug: string | number } } | [page: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const page = {
    show: Object.assign(show, show),
}

export default page